import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * If the URL has a query param `throw_test_error={message}`, throws an Error with that message in a useEffect.
 * Useful to manually trigger the ErrorBoundary for testing (e.g. ?throw_test_error=Something%20went%20wrong).
 */
export function useTestError(): void {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const message = params.get('throw_test_error');

  useEffect(() => {
    if (message != null && message !== '') {
      throw new Error(message);
    }
  }, [message]);
}
